import React, { FunctionComponent, useContext } from 'react';
import {
  Box, Flex, Button,
  HStack,
  GridItem,
  Grid,
} from '@chakra-ui/react';
import router from 'next/router';
import BasketIcon from '../../basket/basketIcon';
import isMobile, { useCompactNav } from '../../../utils/isMobile';
import NavLink from '../../navigation/navLink';
import { NavigationContext } from '../../../lib/contexts/NavigationContext';
import Logo from '../../logo';
import PreviewToggle from '../../navigation/PreviewToggle';
import LoginButton from '../../login/LoginButton';
import ClassBooking from '../../navigation/NavMenus/ClassBooking';
import MyAccountNav from '../../navigation/NavMenus/MyAccount';
import EventBookingNav from '../../navigation/NavMenus/EventBookingNav';
import MobileNav from '../../navigation/MobileNav';

const Header: FunctionComponent = (props) => {
  const ref = React.useRef(null);

  const { paths } = useContext(NavigationContext);
  const compactNav = useCompactNav();
  const phone = isMobile();

  return (
    <Flex
      ref={ref}
      as="nav"
      align="center"
      flexGrow={1}
      padding={3}
      backgroundColor="#ffffff"
      width="100%"
      justifyContent="center"
      {...props}
    >
      <Grid gridTemplateColumns={['200px 1fr', '200px 1fr']} width={['100%', '100%', '90%']} maxWidth={['100%', '100%', '1200px']}>
        <GridItem display="flex" alignItems="center" justifyContent="left">
          <Button onClick={() => router.push(paths.root)} variant="unstyled" h="auto">
            <Logo />
          </Button>
        </GridItem>
        <GridItem display="flex" alignItems="center" justifyContent="right">
          <Box
            mt={{ base: 0, md: 0 }}
            alignItems="center"
          >
            <HStack>

              {!compactNav && (
                <Box pr={4}>
                  <HStack>
                    <PreviewToggle />
                    <NavLink label="About Us" action={() => router.push('https://ukchinaperformingarts.com/about-ukcpa')} />
                    <ClassBooking />
                    <EventBookingNav />
                    <MyAccountNav />
                  </HStack>
                </Box>
              )}

              {/* Phones reach the basket from the footer bar, which only
                  shows below md; from md the header keeps the basket even
                  while the rest of the navigation sits in the menu. */}
              {!phone && <BasketIcon />}
              {!compactNav && <LoginButton />}

              <MobileNav />
            </HStack>
          </Box>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default Header;
